(function() {
    if (customElements.get('base-multi-select') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
          --base-multi-select-radius: .5em;
          --base-multi-select-border: 1px solid currentColor;
          --base-multi-select-default-dropdown-bg: #ffffff;
          --base-multi-select-default-dropdown-box-shadow: .1em .1em .2em rgba(0, 0, 0, .25);
          --base-multi-select-arrow-container-width: 2rem;
          --base-multi-select-inner-space: .5em;
          --base-multi-select-prefix-size: 1em;
          --base-multi-select-prefix-opacity-inactive: 0;
          --base-multi-select-prefix-opacity-active: 1;
          --base-multi-select-item-hover-bg: currentColor;
          --base-multi-select-item-hover-bg-opacity: .1;
          box-sizing: border-box;
          display: inline-grid;
          width: min(100%, 240px);
          grid-template-columns: auto var(--base-multi-select-arrow-container-width);
          gap: var(--base-multi-select-inner-space);
          align-items: center;
          cursor: default;
          border-radius: var(--base-multi-select-radius);
          border: var(--base-multi-select-border);
        }
        [part="label"] {
            grid-column: 1;
            grid-row: 1;
            box-sizing: border-box;
            padding-inline: var(--base-multi-select-inner-space);
            padding-block: var(--base-multi-select-inner-space);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        [part="arrow"] {
            grid-column: 2;
            grid-row: 1;
        }
        [part="default-arrow"] {
            width: 1rem;
            height: 1rem;
            margin: auto;
        }
        [part="original"] {
            position: absolute;
            width: 1px;
            height: 1px;
            opacity: 0;
            z-index: -1;
            touch-action: none;
        }
        [part="dropdown"] {
            grid-column: 1 / -1;
            grid-row: 1;
            position: relative;
            z-index: 1;
            display: none;
            height: 100%;
        }
        :host([open]) [part="dropdown"] {
            display: block;
        }
        [part="default-dropdown"], slot[name="dropdown"]::slotted(menu) {
            padding: 0;
            margin: 0;
            position: absolute;
            left: 0;
            right: 0;
            top: 100%;
            background: var(--base-multi-select-default-dropdown-bg);
            box-shadow: var(--base-multi-select-default-dropdown-box-shadow);
        }
        [part="default-item"] {
            appearance: none;
            background: transparent;
            font-size: inherit;
            width: 100%;
            box-sizing: border-box;
            border: 0;
            isolation: isolate;
            position: relative;
            text-align: left;
            padding-inline: var(--base-multi-select-inner-space);
            padding-block: var(--base-multi-select-inner-space);
            display: flex;
            gap: var(--base-multi-select-inner-space);
            align-items: center;
        }
        [part="item-prefix"] {
            flex: 0 0 var(--base-multi-select-prefix-size);
        }
        [part="item-label"] {
            flex: 1 0 auto;
        }
        [part="default-item"]:first-of-type {
            padding-top: calc(var(--base-multi-select-inner-space) * 2);
        }
        [part="default-item"]:last-of-type {
            padding-top: calc(var(--base-multi-select-inner-space) * 2);
        }
        [part="default-item"]::before {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: var(--base-multi-select-item-hover-bg);
            opacity: 0;
            content: "";
        }
        [part="default-item"]:hover::before {
            opacity: var(--base-multi-select-item-hover-bg-opacity);
        }
        [part="default-item"][data-highlighted="true"]::before {
            opacity: var(--base-multi-select-item-hover-bg-opacity);
        }
        [part="item-prefix"] svg {
            width: var(--base-multi-select-prefix-size);
            height: var(--base-multi-select-prefix-size);
        }
        [part="item-prefix"] {
            opacity: var(--base-multi-select-prefix-opacity-inactive);
        }
        [part="default-item"]:is([data-active="true"]) [part="item-prefix"] {
            opacity: var(--base-multi-select-prefix-opacity-active);
        }
        </style>
        <div part="label"></div>
        <div part="arrow">
            <slot name="arrow">
                <svg part="default-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>            
            </slot>        
        </div>
        <div part="original">
            <slot></slot>
        </div>
        <div part="dropdown">
            <slot name="dropdown">
                <menu part="default-dropdown"></menu>
            </slot>
            <slot name="dropdown-item-template">
                <template part="default-dropdown-item-template">
                    <button type="button" part="default-item" data-active="false" data-value="\${value}" tabindex="0">
                        <span part="item-prefix">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                <path d="M 13.656854,3.7573593 12.242641,2.3431458 2.3431458,12.242641 3.7573593,13.656854 Z M 12.242641,13.656854 13.656854,12.242641 3.7573593,2.3431458 2.3431458,3.7573593 Z" />
                            </svg>
                        </span>
                        <span part="item-label">\${label}</span>
                    </button>
                </template>
            </slot>
        </div>
        `;

        customElements.define('base-multi-select', class extends HTMLElement {

            /**
             * @return {?HTMLSelectElement}
             */
            get selectElement() {
                return this.shadowRoot.querySelector('slot:not([name])').assignedElements()[0] ?? null;
            }

            /**
             * @return {HTMLOptionElement[]}
             */
            get options() {
                const select = this.selectElement;
                if (select === null) {
                    return [];
                }
                return Array.from(select.options);
            }

            get selectedOptions() {
                return this.options.filter(option => option.selected);
            }

            /**
             * @returns {string[]}
             */
            get selection() {
                return this.selectedOptions.map(option => option.value);
            }

            constructor() {
                super();
                this.addEventListener('slotchange', event => {
                    this.connectSelect();
                });
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this.addEventListener('focusin', () => this.openDropdown());
                this.addEventListener('click', event=> {
                    const select = this.selectElement;
                    if (select && event.target !== select && !select.contains(event.target)) {
                        select.focus();
                    }
                });
                this.closeDropdown = () => void(0);
            }

            openDropdown() {
                if (this.hasAttribute('open')) {
                    return;
                }
                this.setAttribute('open', 'open');
                this.dispatchEvent(new CustomEvent('base-multi-select.open', {
                    bubbles: true
                }));

                // Simple counter to track which option to toggle next when using keyboard navigation
                let currentIndex = 0;
                const blur = (event) => {
                    if (event.target !== this && this.contains(event.target) === false) {
                        this.closeDropdown();
                    }
                };
                const keydown = (event) => {
                    const hasHighlight = this.dropdown.querySelector('[part="default-item"][data-highlighted]') !== null;
                    if (event.key === "Escape" || event.key === "Tab") {
                        this.closeDropdown();
                    } else if ((!this.selectElement.multiple && (event.key === "Enter" || event.code === "Space")) || (this.selectElement.multiple && event.key === "Enter") ) {
                        // is this correct?
                        event.preventDefault();
                        this.closeDropdown();
                    } else if (this.selectElement.multiple) {
                        if (event.key === "ArrowDown") {
                            event.preventDefault();
                            if (hasHighlight) {
                                currentIndex = Math.min(currentIndex + 1, this.selectElement.options.length - 1);
                            } else {
                                currentIndex = 0;
                            }
                            this.updateHighlight(currentIndex);
                        } else if (event.key === "ArrowUp") {
                            event.preventDefault();
                            if (hasHighlight) {
                                currentIndex = Math.max(currentIndex - 1, 0);
                            } else {
                                currentIndex = Math.max(this.dropdown.querySelectorAll('[part="default-item"]').length - 1, 0);
                            }
                            this.updateHighlight(currentIndex);
                        } else if (event.code === "Space") {
                            event.preventDefault();
                            const optionToToggle = this.selectElement.options[currentIndex];
                            if (optionToToggle) {
                                this.toggleOption(optionToToggle.value);
                            }
                        }
                    }
                };

                this.closeDropdown = () => {
                    this.dispatchEvent(new CustomEvent('base-multi-select.close', {
                        bubbles: true,
                    }));
                    this.removeAttribute('open');
                    document.removeEventListener('click', blur);
                    document.removeEventListener('focusin', blur);
                    this.removeEventListener('keydown', keydown);
                    this.closeDropdown = () => void(0);
                };

                document.addEventListener('click', blur);
                document.addEventListener('focusin', blur);
                this.addEventListener('keydown', keydown);
            }

            connectSelect() {
                const select = this.selectElement;
                if (select === null) {
                    return;
                }
                const dropdown = this.dropdown;
                const itemTemplate = this.itemTemplate;
                const tmp = document.createElement('div');
                dropdown.innerHTML = "";
                const items = Array.from(select.options).map(option => {
                    let html = itemTemplate.innerHTML;
                    html = html.replace('{$value}', '${value}');
                    html = html.replace('{$label}', '${label}');
                    tmp.innerHTML = html.replace('${value}', option.value).replace('${label}', option.label);
                    const item = tmp.firstElementChild;
                    // this is never fired because focus is on real select
                    // question: then why keep it here?
                    item.addEventListener('keydown', event => {
                        if (event.key === "Enter" || event.code === "Space") {
                            event.preventDefault();
                            item.dispatchEvent(new Event('click', {
                                bubbles: true
                            }));
                        }
                    });
                    item.addEventListener('click', (event) => {
                        if (event.currentTarget.dataset.value !== undefined) {
                            this.toggleOption(event.currentTarget.dataset.value);
                        }
                        if (select.multiple) {
                            item.focus();
                        }
                        event.stopPropagation();
                    });
                    return item;
                });
                const fragment = document.createDocumentFragment();
                items.forEach(item => fragment.appendChild(item));
                dropdown.appendChild(fragment);
                const setState = () => {
                    this.updateLabel();
                    const selection = this.selection;
                    items.filter(item => item.dataset.active !== null).forEach(item => {
                        item.dataset.active = selection.indexOf(item.dataset.value) > -1 ? 'true' : 'false';
                    });
                    return selection;
                };
                select.addEventListener('change', () => {
                    const selection = setState();
                    this.dispatchEvent(new CustomEvent('changed', {
                        detail: {
                            selection
                        },
                        bubbles: true,
                    }));
                });
                setState();
                return select;
            }

            /**
             * @return {HTMLElement}
             */
            get dropdown() {
                return this.querySelector('[slot="dropdown"]') ??
                    this.shadowRoot.querySelector('[part="default-dropdown"]');
            }

            /**
             * @return {HTMLTemplateElement}
             */
            get itemTemplate() {
                return this.querySelector('template[slot="dropdown-item-template"]')
                    ?? this.shadowRoot.querySelector('template[part="default-dropdown-item-template"]');
            }

            /**
             * @return {string[]}
             */
            get selectedLabels() {
                return this.selectedOptions.map(option => option.innerHTML);
            }

            toggleOption(value) {
                const select = this.selectElement;
                if (select === null) {
                    return;
                }
                for (let option of Array.from(select.options)) {
                    if (option.value === value) {
                        option.selected = !option.selected;
                        if (!select.multiple) {
                            this.closeDropdown();
                        }
                        break;
                    }
                }
                select.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }

            updateLabel() {
                const selection = this.selectedLabels;
                this.shadowRoot.querySelector('[part="label"]').innerHTML = selection.length === 0
                    ? this.getAttribute('empty-label')
                    : selection.join(", ");
            }

            updateHighlight(highlightedIndex) {
                // Remove previous highlight from all items
                const items = this.dropdown.querySelectorAll('[part="default-item"]');
                items.forEach(item => item.removeAttribute('data-highlighted'));

                // Add highlight to current item
                if (highlightedIndex >= 0 && highlightedIndex < items.length) {
                    items[highlightedIndex].setAttribute('data-highlighted', 'true');
                }
            }

            connectedCallback() {
                this.connectSelect();
                this.updateLabel();
            }

            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'empty-label') {
                    if (this.selection.length === 0) {
                        this.updateLabel();
                    }
                }
            }
        });
    }
})();
